module.exports = __webpack_public_path__ + "img/pascal_avatar.a559dafe.jpg";